<template>
  <div class="flex flex-col gap-8 justify-center items-center h-[70vh]">
    <BaseImage src="/images/checkbox.png" class="w-32" alt="Success checkbox" />
    <slot name="heading"> </slot>
    <slot name="text"> </slot>
    <slot name="cta"> </slot>
  </div>
</template>
